import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PAGE_SIZE_CONSTANT } from "../../constants";
import { Ticket } from "../tickets/types";
import { 
    ExploreEventsError,
    ExploreEventsState,
    EventDetails,
    FetchEventParams,
    FetchTicketsByEventIdParams,
    FetchEventsParams
} from "./types";

const initialState: ExploreEventsState = {
    useConstraints: false,
    constraints: {
        startDatetime: new Date(),
        endDatetime: new Date(),
        eventNameContains: "",
        onlyShowAvailableEvents: false,
    },
    events: new Map<number, EventDetails>(),
    ticketsForEvents: new Map<number, Ticket[]>(...[]),
    loading: false, 
    loadingTickets: false,
    error: ExploreEventsError.NONE,
    pageSize: PAGE_SIZE_CONSTANT,
    // Starting from 1
    currentPage: 1
}

export const fetchEvents = createAsyncThunk('events/fetchEvents',
    async (args: FetchEventsParams) => {

    console.log('startbad');
    const eventsRes = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/event?limit=${args.limit}&offset=${args.offset}`);
    console.log("2str", eventsRes)

    if(eventsRes.status != 200) Error("EVENTS_FETCH_FAILURE")

    const events: EventDetails[] = await eventsRes.json().then((json) => json.result);

    console.log("eventsss777", events);

    return events
})

export const fetchEvent = createAsyncThunk('events/fetchEvent',
    async (args: FetchEventParams) => {

    console.log(args.eventId);
    const eventRes = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/event/${args.eventId}`);

    if(eventRes.status != 200){
      // It's good to log the status and possibly the statusText to understand the type of failure
      console.error("Failed to fetch event:", eventRes.status, eventRes.statusText);
        throw Error("EVENTS_FETCH_FAILURE");
    } 

    const jsonResponse = await eventRes.json();
    console.log("Checkinggg", jsonResponse); // Now you only read and log the response once

    const event: EventDetails = jsonResponse.result;
    // Assuming jsonResponse.result is the actual event data you want
    // If jsonResponse is the actual data, then you should directly assign it to 'event'
    // const event: EventDetails = jsonResponse;

    return event; // This will be the payload for the fulfilled action
})

export const fetchTicketsForEvent = createAsyncThunk('events/fetchTicketsForEvent',
    async (args: FetchTicketsByEventIdParams) => {
      
    console.log('start');
    const ticketsRes = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/event/tickets?eventId=${args.eventId}`);

    if(ticketsRes.status != 200) Error("TICKETS_FETCH_FAILURE");

    const json = await ticketsRes.json();

    // Add 

    return {tickets: json.result, eventId: args.eventId } as {tickets: Ticket[], eventId: number};
})

export const eventsSlice = createSlice({
    name: 'events',
    initialState,
    reducers: {
        loading: (state) => { state.loading = true },
        fetched: (state) => { state.loading = false },
        clear: (state) => { state = initialState },
    },
    extraReducers: (builder) => {
        // === Fetch events ===
        builder.addCase(fetchEvents.pending, (state) => {
            console.log('PENDING');
            state.loading = true
        })
        builder.addCase(fetchEvents.fulfilled, (state, action: PayloadAction<EventDetails[]>) => {
            console.log('FULFILLED');
            // Add new events to state
            const newEventsMap = new Map<number, EventDetails>();
            action.payload.map((event) => newEventsMap.set(event.id, event));
            console.log("Pat", newEventsMap);
            console.log("Patt",action.payload);

            // action.payload.map((event) => newEventsMap.set(event.id, event));
            // state.events.forEach((event, eventId) => {
            //     if(!newEventsMap.has(eventId)) newEventsMap.set(eventId, event)
            // });

            state.events = newEventsMap;
            state.loading = false;
            state.error = ExploreEventsError.NONE;
        })
        builder.addCase(fetchEvents.rejected, (state) => {
            console.log('REJECTED');
            state.error = ExploreEventsError.LOADING_FAILED;
        })

        // === Fetch single event ===
        builder.addCase(fetchEvent.pending, (state) => {
            console.log('PENDING');
            state.loading = true
        })

        /////////////////////////////////////////////////////////////////
        builder.addCase(fetchEvent.fulfilled, (state, action: PayloadAction<EventDetails>) => {
            console.log('FULFILLED');
            // Add new event to state

            const newEventsMap = new Map<number, EventDetails>();
            // Add all existing events to new map
            console.log("Patt",action.payload);
            console.log(state.events.size);
            if(state.events.size && state.events.size > 0) {
                state.events.forEach((event) => {
                    newEventsMap.set(event.id, event)
                })
            }
            newEventsMap.set(action.payload.id, action.payload);
            console.log("Pat", newEventsMap);


            state.events = newEventsMap;
            // console.log(newEventsMap);
            state.loading = false;
            state.error = ExploreEventsError.NONE;
        })
        builder.addCase(fetchEvent.rejected, (state) => {
            console.log('REJECTED');
            state.error = ExploreEventsError.EVENT_FETCH_FAILURE;
        })

        // === Fetch tickets for events ===
        builder.addCase(fetchTicketsForEvent.pending, (state) => {
            console.log('PENDING');
            state.loadingTickets = true
        })
        builder.addCase(fetchTicketsForEvent.fulfilled, (state, action: PayloadAction<{tickets: Ticket[], eventId: number}>) => {
            console.log('FULFILLED');
            console.log(action.payload);
            console.log(state.ticketsForEvents);
            state.ticketsForEvents = new Map<number, Ticket[]>();
            console.log(state.ticketsForEvents);
            state.ticketsForEvents.set(action.payload.eventId, action.payload.tickets);
            console.log(state.ticketsForEvents);
            // state.ticketsForEvents.set(action.payload.eventId, action.payload.tickets);
            state.loadingTickets = false;
            state.error = ExploreEventsError.NONE;
        })
        builder.addCase(fetchTicketsForEvent.rejected, (state) => {
            console.log('REJECTED');
            state.loadingTickets = false;
            state.error = ExploreEventsError.EVENT_TICKETS_FAILURE;
        })
    }
})

// Selectors
export const selectEvent = (state: ExploreEventsState, eventId: number) => {
    if(state.events.size && state.events.has(eventId))
        return state.events.get(eventId)
    else
        return undefined
};
export const selectTicketsForEvent = (state: ExploreEventsState, eventId: number) => {
    if(state.ticketsForEvents == undefined) return undefined;
    if(state.ticketsForEvents.size && state.ticketsForEvents.has(eventId))
        return state.ticketsForEvents.get(eventId)
    else
        return undefined
}
export const selectEvents = (state: ExploreEventsState) => state.events;
export const selectEventErrors = (state: ExploreEventsState) => state.error;
export const selectEventConstraints = (state: ExploreEventsState) => state.constraints;
export const selectLoadingStatus = (state: ExploreEventsState) => state.loading;

export default eventsSlice.reducer